import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import OrganizationReducer from './OrganizationReducer';
import { organizationReducerKey } from './OrganizationConstants';
import Organization from './Organization';
import { login, goToLoginPage } from './OrganizationActions';
import { isLoading as isLoadingSelector } from './OrganizationSelectors';

const mapStateToProps = (state, ownProps) => ({
  isLoading: isLoadingSelector(state),
  ...ownProps,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  login: (path) => dispatch(login(path, ownProps.response)),
  goToLoginPage: () => goToLoginPage(),
  ...ownProps,
});

export default compose(
  withCombinedRouteParams,
  withReducer(organizationReducerKey, OrganizationReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(Organization);
